import { Injectable } from '@angular/core';
import { AppsService } from 'app/shared/services/apps.service';


@Injectable({
    providedIn: 'root'
})
export class DropDownFilterService {

    fltr_api_res = {
        ConstuencyLst: [],
        rgnLst: [],
        dstrctLst: {},
        districtLst: [],
        mandalsLst: {},
        constyLst:{},
        ulbLst: {},
        GPLst: {},
        SVMLst: {},
        lctnsLst : {},
        habitationlist: {},
        svmlist:{},
        wrkNtreLst: [],
        wrkTypLst: [],
        phaseNumbersLst: [],
        wrkSubTypLst: {},
        wrkstatusLst: [],
        propertyTypeLst: [],
        propertyUsageLst: [],
        constructionTypeLst: [],
        WRDLst: {},
        ELEWRDLst: {},
        CLSTRNOLst: {},
        LcltyLst: [],
        sroLst: [],
        HbtnLst: [],
        pinCdLst: [],
        StrtLst: [],
        dvsn_lst: [],
        stateLst: [],
        yrs_lst:[],
        fnd_lst:[],
        ClusterLst:[],
        ClstrGPLst:[],

    }

    constructor(private apiSrv: AppsService) { }


    getPropertyTypes(clbk) {
        if (this.fltr_api_res.propertyTypeLst.length == 0) {
            this.apiSrv.get(`admin/property/type`).subscribe((res) => {
                if (res['status'] == 200) {
                    this.fltr_api_res.propertyTypeLst = res['data'];
                    clbk({
                        fltr_res: this.fltr_api_res.propertyTypeLst,
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.propertyTypeLst, 'prcl_type_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.propertyTypeLst, 'prcl_type_nm')
                    })
                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.propertyTypeLst,
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.propertyTypeLst, 'prcl_type_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.propertyTypeLst, 'prcl_type_nm')
            })
        }

    }
    getConstuencyLst(dstrt_id, clbk) {
        if (this.fltr_api_res.ConstuencyLst.length == 0) {
            this.apiSrv.get(`admin/wms/constituencies/${dstrt_id || 0}`).subscribe((res) => {
                if (res['status'] == 200) {
                    this.fltr_api_res.ConstuencyLst = res['data'];
                    clbk({
                        fltr_res: this.fltr_api_res.ConstuencyLst,
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.ConstuencyLst, 'cnsty_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.ConstuencyLst, 'cnsty_nm')
                    })
                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            })
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.ConstuencyLst,
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.ConstuencyLst, 'cnsty_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.ConstuencyLst, 'cnsty_nm')
            })
        }
    }
    getPropertyUsage(clbk) {
        if (this.fltr_api_res.propertyUsageLst.length == 0) {
            this.apiSrv.get(`admin/property/usage`).subscribe((res) => {
                if (res['status'] == 200) {
                    this.fltr_api_res.propertyUsageLst = res['data'];
                    clbk({
                        fltr_res: this.fltr_api_res.propertyUsageLst,
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.propertyUsageLst, 'prcl_usge_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.propertyUsageLst, 'prcl_usge_nm')
                    })
                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.propertyUsageLst,
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.propertyUsageLst, 'prcl_usge_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.propertyUsageLst, 'prcl_usge_nm')
            })
        }

    }
    getConstructionTypes(clbk) {
        if (this.fltr_api_res.constructionTypeLst.length == 0) {
            this.apiSrv.get(`admin/construction/type`).subscribe((res) => {
                if (res['status'] == 200) {
                    this.fltr_api_res.constructionTypeLst = res['data'];
                    // // console.log(this.fltr_api_res.constructionTypeLst, 'hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh')


                    clbk({
                        fltr_res: this.fltr_api_res.constructionTypeLst,
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.constructionTypeLst, 'cnstn_type_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.constructionTypeLst, 'cnstn_nm')
                    })
                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.constructionTypeLst,
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.constructionTypeLst, 'cnstn_type_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.constructionTypeLst, 'cnstn_nm')
            })
        }

    }

    getRgns(clbk) {
        if (this.fltr_api_res.rgnLst.length == 0) {
            this.apiSrv.get(`admin/rgn`).subscribe((res) => {
                if (res['status'] == 200) {
                    this.fltr_api_res.rgnLst = res['data'];
                    clbk({
                        fltr_res: this.fltr_api_res.rgnLst,
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.rgnLst, 'rgn_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.rgnLst, 'rgn_nm')
                    })
                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.rgnLst,
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.rgnLst, 'rgn_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.rgnLst, 'rgn_id')
            })
        }

    }


    getsts(clbk) {
        if (this.fltr_api_res.stateLst.length == 0) {
            // console.log("aaaaaaaaaaaaa")
            this.apiSrv.get(`admin/steLst`).subscribe((res) => {
                if (res['status'] == 200) {
                    // console.log("yyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyy", res['data'])
                    this.fltr_api_res.stateLst = res['data'];
                    clbk({
                        fltr_res: this.fltr_api_res.stateLst,
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.stateLst, 'ste_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.stateLst, 'ste_nm')
                    })
                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            // console.log("elseeeeeeeeeeee")
            clbk({
                fltr_res: this.fltr_api_res.stateLst,
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.stateLst, 'ste_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.stateLst, 'ste_nm')
            })
        }

    }
    getDistrictsByRgn(rgn_id, clbk) {
        // console.log(rgn_id)
        if (!this.fltr_api_res.dstrctLst[`rgn_${rgn_id}`] || this.fltr_api_res.dstrctLst[`rgn_${rgn_id}`].length == 0) {
            this.apiSrv.get(`admin/dstrcts/${rgn_id}`).subscribe((res) => {
                if (res['status'] == 200) {
                    // console.log(res)

                    this.fltr_api_res.dstrctLst = res['data'];
                    clbk({
                        fltr_res: this.fltr_api_res.dstrctLst,
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.dstrctLst, 'dstrt_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.dstrctLst, 'dstrt_nm')
                    })
                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.dstrctLst,
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.dstrctLst, 'dstrt_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.dstrctLst, 'dstrt_nm')
            })
        }

    }
  


    getStates(clbk) {
        // console.log(this.fltr_api_res.stateLst)

        if (this.fltr_api_res.stateLst.length == 0) {
            this.apiSrv.get(`admin/states`).subscribe((res) => {
                if (res['status'] == 200) {
                    this.fltr_api_res.stateLst = res['data'];
                    // console.log(this.fltr_api_res.stateLst)
                    clbk({
                        fltr_res: this.fltr_api_res.stateLst,
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.stateLst, 'ste_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.stateLst, 'ste_nm')
                    })
                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.stateLst,
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.stateLst, 'dstrt_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.stateLst, 'dstrt_nm')
            })
        }

    }

    getDistricts(clbk) {
        // console.log(this.fltr_api_res.districtLst)

        if (this.fltr_api_res.districtLst.length == 0) {
            this.apiSrv.get(`admin/districts`).subscribe((res) => {
                // console.log(res,"distrrrrrrrrrrrrrrrrrrrrr")

                if (res['status'] == 200) {
                    this.fltr_api_res.districtLst = res['data'];
                    // console.log(this.fltr_api_res.districtLst)
                    clbk({
                        fltr_res: this.fltr_api_res.districtLst,
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.districtLst, 'dstrt_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.districtLst, 'dstrt_nm')
                    })
                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.districtLst,
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.districtLst, 'dstrt_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.districtLst, 'dstrt_nm')
            })
        }

    }

    getMandals(dstrt_id, clbk) {
        // console.log('mndallllllllserviceeeeeeeeee')
        if (!this.fltr_api_res.mandalsLst[`dstct_${dstrt_id}`] || this.fltr_api_res.mandalsLst[`dstct_${dstrt_id}`].length == 0) {
            this.apiSrv.get(`admin/mandals/${dstrt_id}`).subscribe((res) => {
                // console.log(res,"mndllllllllllllll")
                if (res['status'] == 200) {
                    this.fltr_api_res.mandalsLst[`dstct_${dstrt_id}`] = res['data'];
                    clbk({
                        fltr_res: this.fltr_api_res.mandalsLst[`dstct_${dstrt_id}`],
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.mandalsLst[`dstct_${dstrt_id}`], 'mndl_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.mandalsLst[`dstct_${dstrt_id}`], 'mndl_nm')
                    })
                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.mandalsLst[`dstct_${dstrt_id}`],
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.mandalsLst[`dstct_${dstrt_id}`], 'mndl_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.mandalsLst[`dstct_${dstrt_id}`], 'mndl_nm')
            })
        }

    }

    getConstuenctandmndls(dstrt_id, clbk) {
        // console.log('mndallllllllserviceeeeeeeeee',dstrt_id)
        if (!this.fltr_api_res.constyLst[`dstct_${dstrt_id}`] || this.fltr_api_res.constyLst[`dstct_${dstrt_id}`].length == 0) {
            this.apiSrv.get(`admin/cnstys/${dstrt_id}`).subscribe((res) => {
                // console.log(res,"mndllllllllllllll")
                if (res['status'] == 200) {
                    this.fltr_api_res.constyLst[`dstct_${dstrt_id}`] = res['data'];
                    clbk({
                        fltr_res: this.fltr_api_res.constyLst[`dstct_${dstrt_id}`],
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.constyLst[`dstct_${dstrt_id}`], 'mndl_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.constyLst[`dstct_${dstrt_id}`], 'mndl_nm')
                    })
                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.constyLst[`dstct_${dstrt_id}`],
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.constyLst[`dstct_${dstrt_id}`], 'cnsty_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.constyLst[`dstct_${dstrt_id}`], 'cnsty_nm')
            })
        }

    }


    getULBs(dstrt_id, clbk) {
        if (!this.fltr_api_res.ulbLst[`dstct_${dstrt_id}`] || this.fltr_api_res.ulbLst[`dstct_${dstrt_id}`].length == 0) {
            this.apiSrv.get(`admin/districts/${dstrt_id}/ulbs`).subscribe((res) => {
                if (res['status'] == 200) {
                    this.fltr_api_res.ulbLst[`dstct_${dstrt_id}`] = res['data'];
                    clbk({
                        fltr_res: this.fltr_api_res.ulbLst[`dstct_${dstrt_id}`],
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.ulbLst[`dstct_${dstrt_id}`], 'ulb_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.ulbLst[`dstct_${dstrt_id}`], 'ulb_nm')
                    })
                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.ulbLst[`dstct_${dstrt_id}`],
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.ulbLst[`dstct_${dstrt_id}`], 'ulb_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.ulbLst[`dstct_${dstrt_id}`], 'ulb_nm')
            })
        }

    }

    getGP(mndl_id, clbk) {
        // console.log(mndl_id,"999999999999999")
        if (!this.fltr_api_res.GPLst[`mdnl_${mndl_id}`] || this.fltr_api_res.GPLst[`mdnl_${mndl_id}`].length == 0) {
            this.apiSrv.get(`admin/wms/gp-lists/${mndl_id}`).subscribe((res) => {
                if (res['status'] == 200) {
                    this.fltr_api_res.GPLst[`mdnl_${mndl_id}`] = res['data'];

                    clbk({
                        fltr_res: this.fltr_api_res.GPLst[`mdnl_${mndl_id}`],
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.GPLst[`mdnl_${mndl_id}`], 'gp_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.GPLst[`mdnl_${mndl_id}`], 'gp_nm')
                    })

                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.GPLst[`mdnl_${mndl_id}`],
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.GPLst[`mdnl_${mndl_id}`], 'gp_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.GPLst[`mdnl_${mndl_id}`], 'gp_nm')
            })
        }


    }
    getClusters(mndl_id, clbk) {
        // console.log(mndl_id, "Getting clusters for mandal")
        if (!this.fltr_api_res.ClusterLst[`mdnl_${mndl_id}`] || this.fltr_api_res.ClusterLst[`mdnl_${mndl_id}`].length == 0) {
            this.apiSrv.get(`admin/wms/cluster-lists/${mndl_id}`).subscribe((res) => {
                if (res['status'] == 200) {
                    this.fltr_api_res.ClusterLst[`mdnl_${mndl_id}`] = res['data'];
    
                    clbk({
                        fltr_res: this.fltr_api_res.ClusterLst[`mdnl_${mndl_id}`],
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.ClusterLst[`mdnl_${mndl_id}`], 'cluster_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.ClusterLst[`mdnl_${mndl_id}`], 'cluster_nm')
                    })
    
                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.ClusterLst[`mdnl_${mndl_id}`],
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.ClusterLst[`mdnl_${mndl_id}`], 'cluster_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.ClusterLst[`mdnl_${mndl_id}`], 'cluster_nm')
            })
        }
    }
    getGPSlctdClusters(clstr_id, clbk) {
        // console.log(clstr_id,"999999999999999")
        if (!this.fltr_api_res.ClstrGPLst[`mdnl_${clstr_id}`] || this.fltr_api_res.ClstrGPLst[`mdnl_${clstr_id}`].length == 0) {
            this.apiSrv.get(`admin/wms/${clstr_id}/gp-lists`).subscribe((res) => {
                if (res['status'] == 200) {
                    this.fltr_api_res.ClstrGPLst[`mdnl_${clstr_id}`] = res['data'];

                    clbk({
                        fltr_res: this.fltr_api_res.ClstrGPLst[`mdnl_${clstr_id}`],
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.ClstrGPLst[`mdnl_${clstr_id}`], 'gp_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.ClstrGPLst[`mdnl_${clstr_id}`], 'gp_nm')
                    })

                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.ClstrGPLst[`mdnl_${clstr_id}`],
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.ClstrGPLst[`mdnl_${clstr_id}`], 'gp_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.ClstrGPLst[`mdnl_${clstr_id}`], 'gp_nm')
            })
        }


    }
    getSVM(ulb_id, clbk) {
        //  // console.log(this.fltr_api_res.SVMLst[`ulb_${ulb_id}`], );
        if (!this.fltr_api_res.SVMLst[`ulb_${ulb_id}`] || this.fltr_api_res.SVMLst[`ulb_${ulb_id}`].length == 0) {
            // // console.log('ennnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnrrrrrrrrrrrrrrrrrrr')
            this.apiSrv.get(`admin/wms/svm/${ulb_id}`).subscribe((res) => {
                if (res['status'] == 200) {
                    this.fltr_api_res.SVMLst[`ulb_${ulb_id}`] = res['data'];
                    //  // console.log(this.fltr_api_res.SVMLst[`ulb_${ulb_id}`],'ssssssssssssssssssssssssssss')
                    clbk({
                        fltr_res: this.fltr_api_res.SVMLst[`ulb_${ulb_id}`],
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.SVMLst[`ulb_${ulb_id}`], 'svm_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.SVMLst[`ulb_${ulb_id}`], 'svm_nm')
                    })
                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            // // console.log(this.fltr_api_res.SVMLst[`ulb_${ulb_id}`] , "pssdfdsdshj")
            clbk({
                fltr_res: this.fltr_api_res.SVMLst[`ulb_${ulb_id}`],
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.SVMLst[`ulb_${ulb_id}`], 'svm_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.SVMLst[`ulb_${ulb_id}`], 'svm_nm')
            })
        }


    }



    getLocations(ulb_id, clbk) {
        if (!this.fltr_api_res.lctnsLst[`ulb_${ulb_id}`] || this.fltr_api_res.lctnsLst[`ulb_${ulb_id}`].length == 0) {
            this.apiSrv.get(`admin/ulb/${ulb_id}/locations`).subscribe((res) => {
                if (res['status'] == 200) {
                    this.fltr_api_res.lctnsLst[`ulb_${ulb_id}`] = res['data'];
                    clbk({
                        fltr_res: this.fltr_api_res.lctnsLst[`ulb_${ulb_id}`],
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.lctnsLst[`ulb_${ulb_id}`], 'lctn_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.lctnsLst[`ulb_${ulb_id}`], 'lctn_nm')
                    })
                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.lctnsLst[`ulb_${ulb_id}`],
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.lctnsLst[`ulb_${ulb_id}`], 'lctn_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.lctnsLst[`ulb_${ulb_id}`], 'lctn_nm')
            })
        }
    }


    getHabitation(gp_id, clbk) {
        if (!this.fltr_api_res.habitationlist[`gp_${gp_id}`] || this.fltr_api_res.habitationlist[`gp_${gp_id}`].length == 0) {
            this.apiSrv.get(`admin/wms/habitations/${gp_id}`).subscribe((res) => {
                if (res['status'] == 200) {
                    this.fltr_api_res.habitationlist[`gp_${gp_id}`] = res['data'];
                    clbk({
                        fltr_res: this.fltr_api_res.habitationlist[`gp_${gp_id}`],
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.habitationlist[`gp_${gp_id}`], 'hbtn_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.habitationlist[`gp_${gp_id}`], 'hbtn_nm'),
                    })

                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
                // console.log(this.fltr_api_res)
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.habitationlist[`gp_${gp_id}`],
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.habitationlist[`gp_${gp_id}`], 'hbtn_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.habitationlist[`gp_${gp_id}`], 'hbtn_nm'),
            })
        }

    }
  

    getWorkNtre(clbk) {
        if (this.fltr_api_res.wrkNtreLst && this.fltr_api_res.wrkNtreLst.length == 0) {

            this.apiSrv.get(`admin/work/nature`).subscribe((res) => {
                if (res['status'] == 200) {
                    this.fltr_api_res.wrkNtreLst = res['data'];

                    clbk({
                        fltr_res: this.fltr_api_res.wrkNtreLst,
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.wrkNtreLst, 'wrk_ntre_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.wrkNtreLst, 'wrk_ntre_nm'),
                    })
                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.wrkNtreLst,
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.wrkNtreLst, 'wrk_ntre_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.wrkNtreLst, 'wrk_ntre_nm'),
            })
        }

    }


    getWorkStats(clbk) {
        if (this.fltr_api_res.wrkstatusLst && this.fltr_api_res.wrkstatusLst.length == 0) {

            this.apiSrv.get(`admin/work/status`).subscribe((res) => {
                if (res['status'] == 200) {
                    this.fltr_api_res.wrkstatusLst = res['data'];

                    clbk({
                        fltr_res: this.fltr_api_res.wrkstatusLst,
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.wrkstatusLst, 'wrk_ntre_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.wrkstatusLst, 'wrk_ntre_nm'),
                    })
                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.wrkstatusLst,
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.wrkstatusLst, 'wrk_ntre_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.wrkstatusLst, 'wrk_ntre_nm'),
            })
        }

    }

    getYrs(clbk){
        if (this.fltr_api_res.yrs_lst && this.fltr_api_res.yrs_lst.length == 0) {
            this.apiSrv.get(`dashboard/get/years`).subscribe((res) => {
                if (res['status'] == 200) {
                    this.fltr_api_res.yrs_lst = res['data'];

                    clbk({
                        fltr_res: this.fltr_api_res.yrs_lst,
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.yrs_lst, 'yr_id')
                    })
                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.yrs_lst,
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.yrs_lst, 'yr_id')
            })
        }
    }

    getfndlst(clbk){
        if (this.fltr_api_res.fnd_lst && this.fltr_api_res.fnd_lst.length == 0) {
            this.apiSrv.get(`admin/get/funds`).subscribe((res) => {
                if (res['status'] == 200) {
                    this.fltr_api_res.fnd_lst = res['data'];

                    clbk({
                        fltr_res: this.fltr_api_res.fnd_lst,
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.fnd_lst, 'yr_id')
                    })
                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.fnd_lst,
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.fnd_lst, 'yr_id')
            })
        }
    }


    getWorkType(clbk) {
        if (this.fltr_api_res.wrkTypLst && this.fltr_api_res.wrkTypLst.length == 0) {

            this.apiSrv.get(`admin/work/categories`).subscribe((res) => {
                if (res['status'] == 200) {
                    this.fltr_api_res.wrkTypLst = res['data'];

                    clbk({
                        fltr_res: this.fltr_api_res.wrkTypLst,
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.wrkTypLst, 'wrk_type_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.wrkTypLst, 'wrk_type_nm')
                    })
                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.wrkTypLst,
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.wrkTypLst, 'wrk_type_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.wrkTypLst, 'wrk_type_nm')
            })
        }


    }
    getWorkTypebyid(data,clbk){
        this.apiSrv.post(data,`admin/work/categoriesbyID`).subscribe((res) => {
            if (res['status'] == 200) {
                this.fltr_api_res.wrkTypLst = res['data'];

                clbk({
                    fltr_res: this.fltr_api_res.wrkTypLst,
                    fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.wrkTypLst, 'wrk_type_id'),
                    fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.wrkTypLst, 'wrk_type_nm')
                })
            } else {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            }
        }, (err) => {
            clbk({
                fltr_res: [],
                fltr_slct_dflt_id: null,
                fltr_slct_dflt_nm: '',
            })
        });

    }



    

    getsubWorkType(wrk_type_id, clbk) {
        if (!this.fltr_api_res.wrkSubTypLst[`wrk_typ_${wrk_type_id}`] || this.fltr_api_res.wrkSubTypLst[`wrk_typ_${wrk_type_id}`].length == 0) {

            this.apiSrv.get(`admin/subwork/types/${wrk_type_id}`).subscribe((res) => {
                if (res['status'] == 200) {
                    this.fltr_api_res.wrkSubTypLst[`wrk_typ_${wrk_type_id}`] = res['data'];

                    clbk({
                        fltr_res: this.fltr_api_res.wrkSubTypLst[`wrk_typ_${wrk_type_id}`],
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.wrkSubTypLst[`wrk_typ_${wrk_type_id}`], 'sb_wrk_type_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.wrkSubTypLst[`wrk_typ_${wrk_type_id}`], 'sb_wrk_type_nm'),
                    })
                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.wrkSubTypLst[`wrk_typ_${wrk_type_id}`],
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.wrkSubTypLst[`wrk_typ_${wrk_type_id}`], 'sb_wrk_type_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.wrkSubTypLst[`wrk_typ_${wrk_type_id}`], 'sb_wrk_type_nm'),
            })
        }
    }

    getPhaseNumbers(clbk) {
        if (this.fltr_api_res.phaseNumbersLst && this.fltr_api_res.phaseNumbersLst.length == 0) {

            this.apiSrv.get(`admin/work/phase/list`).subscribe((res) => {
                if (res['status'] == 200) {
                    this.fltr_api_res.phaseNumbersLst = res['data'];

                    clbk({
                        fltr_res: this.fltr_api_res.phaseNumbersLst,
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.phaseNumbersLst, 'wrk_phs_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.phaseNumbersLst, 'wrk_phs_nm')
                    })
                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.phaseNumbersLst,
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.phaseNumbersLst, 'wrk_phs_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.phaseNumbersLst, 'wrk_phs_nm')
            })
        }


    }


    getDefltVal(array, key) {
        let dflt_val = null;
        if (array && array.length == 1) {
            dflt_val = array[0][key];
        }
        return dflt_val;
    }

    clearFiltersData() {
        this.fltr_api_res = {
            rgnLst: [],
            dstrctLst: {},
            districtLst: [],
            mandalsLst: {},
            constyLst:{},
            ConstuencyLst: [],
            GPLst: {},
            ulbLst: {},
            SVMLst:{},
            svmlist: {},
            lctnsLst : {},
            habitationlist: {},
            wrkNtreLst: [],
            wrkTypLst: [],
            wrkSubTypLst: {},
            wrkstatusLst: [],
            propertyTypeLst: [],
            propertyUsageLst: [],
            constructionTypeLst: [],
            WRDLst: [],
            ELEWRDLst: [],
            CLSTRNOLst: [],
            LcltyLst: [],
            sroLst: [],
            HbtnLst: [],
            pinCdLst: [],
            StrtLst: [],
            dvsn_lst: [],
            stateLst: [],
            yrs_lst:[],
            fnd_lst:[],
            ClusterLst:[],
            ClstrGPLst:[],
            phaseNumbersLst : []
        }
    }

    getWardNo(ulb_id, clbk) {
        // console.log('insideeeeee')
        if (!this.fltr_api_res.WRDLst[`ulb_${ulb_id}`] || this.fltr_api_res.WRDLst[`ulb_${ulb_id}`].length == 0) {
            this.apiSrv.get(`admin/wrd/${ulb_id}`).subscribe((res) => {
                // console.log('enter into root')
                if (res['status'] == 200) {
                    this.fltr_api_res.WRDLst[`ulb_${ulb_id}`] = res['data'];
                    // console.log(this.fltr_api_res.WRDLst[`ulb_${ulb_id}`])

                    clbk({
                        fltr_res: this.fltr_api_res.WRDLst[`ulb_${ulb_id}`],
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.WRDLst[`ulb_${ulb_id}`], 'wrd_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.WRDLst[`ulb_${ulb_id}`], 'wrd_nm')
                    })

                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.WRDLst[`ulb_${ulb_id}`],
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.WRDLst[`ulb_${ulb_id}`], 'wrd_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.WRDLst[`ulb_${ulb_id}`], 'wrd_nm')
            })
        }


    }

    getWardBySvm(svm_id, clbk) {
        this.apiSrv.get(`admin/wrd/svm/${svm_id}`).subscribe((res) => {
            if (res['status'] == 200) {
                clbk({ fltr_res: res['data'] });
            } else {
                clbk({ fltr_res: [] });
            }
        }, () => {
            clbk({ fltr_res: [] });
        });
    }

    getEleWardNo(ulb_id, clbk) {
        // console.log('insideeeeee')
        if (!this.fltr_api_res.ELEWRDLst[`ulb_${ulb_id}`] || this.fltr_api_res.ELEWRDLst[`ulb_${ulb_id}`].length == 0) {

            this.apiSrv.get(`admin/elewrd/${ulb_id}`).subscribe((res) => {
                // console.log('enter into root')
                if (res['status'] == 200) {
                    this.fltr_api_res.ELEWRDLst[`ulb_${ulb_id}`] = res['data'];

                    // console.log(res['data'])
                    clbk({
                        fltr_res: this.fltr_api_res.ELEWRDLst[`ulb_${ulb_id}`],
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.ELEWRDLst[`ulb_${ulb_id}`], 'eltn_wrd_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.ELEWRDLst[`ulb_${ulb_id}`], 'eltn_wrd_nm')
                    })

                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {

            clbk({
                fltr_res: this.fltr_api_res.ELEWRDLst[`ulb_${ulb_id}`],
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.WRDLst[`ulb_${ulb_id}`], 'eltn_wrd_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.WRDLst[`ulb_${ulb_id}`], 'eltn_wrd_nm')
            })
        }


    }

    getClstrdNo(svm_id, clbk) {
        // console.log('insideeeeeerrrrrrrrrrr')
        if (!this.fltr_api_res.CLSTRNOLst[`svm_${svm_id}`] || this.fltr_api_res.CLSTRNOLst[`svm_${svm_id}`].length == 0) {
            this.apiSrv.get(`admin/clustrno/${svm_id}`).subscribe((res) => {
                // console.log('enter into rootssssssssssssssssssssss')
                if (res['status'] == 200) {
                    this.fltr_api_res.CLSTRNOLst[`svm${svm_id}`] = res['data'];

                    clbk({
                        fltr_res: this.fltr_api_res.CLSTRNOLst[`svm${svm_id}`],
                        fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.CLSTRNOLst[`svm${svm_id}`], 'tu_id'),
                        fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.CLSTRNOLst[`svm${svm_id}`], 'tu_nm')
                    })

                } else {
                    clbk({
                        fltr_res: [],
                        fltr_slct_dflt_id: null,
                        fltr_slct_dflt_nm: '',
                    })
                }
            }, (err) => {
                clbk({
                    fltr_res: [],
                    fltr_slct_dflt_id: null,
                    fltr_slct_dflt_nm: '',
                })
            });
        }
        else {
            clbk({
                fltr_res: this.fltr_api_res.CLSTRNOLst[`mdnl_${svm_id}`],
                fltr_slct_dflt_id: this.getDefltVal(this.fltr_api_res.CLSTRNOLst[`mdnl_${svm_id}`], 'tu_id'),
                fltr_slct_dflt_nm: this.getDefltVal(this.fltr_api_res.CLSTRNOLst[`mdnl_${svm_id}`], 'tu_nm')
            })
        }


    }








}